import React, { useState, useEffect } from 'react'
import {
  Button,
  Cascader,
  Checkbox,
  CheckboxGroup,
  Col,
  ControlLabel,
  Icon,
  IconButton,
  Input,
  InputNumber,
  MultiCascader,
  Panel,
  Radio,
  RadioGroup,
  Rate,
  Row,
  SelectPicker,
  Toggle,
  TreePicker,
} from 'rsuite'
import { useForm, Controller, useFieldArray } from 'react-hook-form'
import InputForm from '../../components/forms/input/InputForm'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import NumberFormat from 'react-number-format'
import classNames from 'classnames'
import notification from '../../utils/notification'
import ShowLimitLength from '../../components/utils/ShowLimitLength'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../constants/pathname'
import { getValueFromOptions } from '../../utils/dataUtil'
import { budgetFormat } from '../../utils/formatterUtil'
import { cloneDeep, isEmpty } from 'lodash-es'
import {
  deleteAssessmentConfigFormByCategoryId,
  deleteAssessmentConfigFormByQuestionId,
  saveAssessmentConfigForm,
  saveAssessmentConfigFormHeader,
  updateAssessmentConfigCategoryForm,
} from '../../redux/actions/assessment'
import { doneLoading, startLoading } from '../../utils/loading'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import EditButton from '../../components/buttons/editButton/EditButton'
import { DATE_FORMAT } from '../../constants/date'

export default function AddEvaluationFormWidget({ schema, isAddNew, ...props }) {
  const {
    register,
    control,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm()

  const [formSchema, setFormSchema] = useState(schema)

  const [assessmentName, setAssessmentName] = useState()
  const [assessmentShowName, setAssessmentShowName] = useState()
  const [assessmentDescription, setAssessmentDescription] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [budgetStart, setBudgetStart] = useState()
  const [budgetEnd, setBudgetEnd] = useState()
  const [statusVal, setStatusVal] = useState(null)
  const [assessmentForVal, setAssessmentForVal] = useState(null)
  const [isDep6, setIsDep6] = useState(false)
  const [disabledForm, setDisabledForm] = useState(false)

  const [questionBlocks, setQuestionBlocks] = useState(schema.form.assessmentCategory)
  const [isShowSelectCategoryType, setIsShowSelectCategoryType] = useState(false)
  const [categoryTypeSelected, setCategoryTypeSelected] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isEditHeader, setIsEditHeader] = useState(isAddNew ? true : false)
  const [isShowConfirmSaveHeader, setIsShowConfirmSaveHeader] = useState(false)
  const [isShowConfirmDeleteCategory, setIsShowConfirmDeleteCategory] = useState(false)
  const [isShowConfirmDeleteQuestion, setIsShowConfirmDeleteQuestion] = useState(false)
  const [deleteId, setDeleteId] = useState()
  const [deleteIndex, setDeleteIndex] = useState()
  const [isNewBlock, setIsNewBlock] = useState(false)
  const [deleteBlockId, setDeleteBlockId] = useState()
  const [deleteQuizIndex, setDeleteQuizIndex] = useState()

  const history = useHistory()

  const assessmentId = sessionStorage.getItem('assessmentId')

  useEffect(() => {
    setHeaderValueFromSchema()
  }, [formSchema])

  useEffect(() => {
    if (isAddNew) {
      setIsShowSelectCategoryType(true)
    } else {
      setCategoryTypeSelected(schema?.form?.categoryType?.value)
    }
  }, [isAddNew])

  const setHeaderValueFromSchema = () => {
    if (formSchema) {
      setAssessmentName(formSchema?.form?.assessmentName?.value)
      setAssessmentShowName(formSchema?.form?.assessmentShowName?.value)
      setAssessmentDescription(formSchema?.form?.assessmentDescription?.value)
      setStartDate(formSchema?.form?.startDate?.value)
      setEndDate(formSchema?.form?.endDate?.value)
      setBudgetStart(formSchema?.form?.budgetStart?.value)
      setBudgetEnd(formSchema?.form?.budgetEnd?.value)
      setStatusVal(formSchema?.form?.assessmentStatus?.value)
      setAssessmentForVal(formSchema?.form?.assessmentFor?.value)
      setIsDep6(formSchema?.form?.isDep6)
      setDisabledForm(formSchema?.form?.disabledForm)
    }
  }

  function createEmptyBlock() {
    return {
      id: null,
      assessmentType: null, //หมวดหมู่แบบสอบถาม
      isEditCategory: false,
      isNew: true,
      questions: [createEmptyQuestion()],
    }
  }

  function createEmptyQuestion() {
    return {
      // id: `cat-${uuidv4()}`,
      // questionType: 1, //ประเภทคำถาม
      // questionName: 'ระบุคำถาม', //ชื่อคำถาม
      // radioAndCheckBoxOptions: ['ตัวเลือกที่ 1'],
      // ratingMaximum: 5,
      // required: true,
      // weight: 0,

      id: `quiz-${uuidv4()}`,
      questionType: 1,
      questionName: 'ระบุคำถาม',
      radioAndCheckBoxOptions: [
        {
          id: `${uuidv4()}`,
          label: null,
          value: 'ตัวเลือกที่ 1',
          sequence: 1,
          score: 0,
          questionId: null,
        },
      ],
      ratingMaximum: 5,
      required: true,
      dimensionWeight: 0,
      ratioWeight: 0,
      preposition: 0,
      component: 0,
      description: null,
      isEdit: true,
      score: 0,
    }
  }

  const handleSaveQuestion = async (request, blockId, quizId) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await saveAssessmentConfigForm(request)
      if (response) {
        setFormSchema(response)

        updateQuestionAndChoice(blockId, quizId, 'isEdit', false)
        updateQuestionBlock(blockId, 'isNew', false)

        if (request.question.questionType == 1 || request.question.questionType == 2) {
          var arr = request.question.radioAndCheckBoxOptions.filter((i) => i.isDeleted != true)
          updateQuestionAndChoice(blockId, quizId, 'radioAndCheckBoxOptions', [...arr])
        }
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        notification.open('error', {
          title: e.response.data.errors?.message,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleSaveHeader = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await saveAssessmentConfigFormHeader(request)

      if (response) {
        setFormSchema(response)
        setIsEditHeader(false)
        sessionStorage.setItem('assessmentId', response.assessmentId)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        notification.open('error', {
          title: e.response.data.errors?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    }
    setIsShowConfirmSaveHeader(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleDeleteCategory = async () => {
    setIsLoading(true)
    startLoading()

    try {
      if (isNewBlock) {
        //handleRemoveBlock(deleteId)
        handleRemoveBlockByIndex(deleteIndex)
        setDeleteId()
        setDeleteIndex()
        setIsNewBlock(false)
      } else {
        const response = await deleteAssessmentConfigFormByCategoryId(deleteId)

        if (response) {
          setFormSchema(response)
          setDeleteId()
          setIsNewBlock(false)
          handleRemoveBlock(deleteId)
          //sessionStorage.setItem('assessmentId', response.assessmentId)
        }
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        notification.open('error', {
          title: e.response.data.errors?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    }
    setIsShowConfirmDeleteCategory(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleDeleteQuestion = async () => {
    setIsLoading(true)
    startLoading()

    try {
      if (deleteId.indexOf('quiz-') != -1) {
        handleRemoveQuestion(deleteBlockId, deleteQuizIndex)
      } else {
        const response = await deleteAssessmentConfigFormByQuestionId(deleteId)

        if (response) {
          setFormSchema(response)
          setDeleteId()
          setDeleteBlockId()
          setDeleteQuizIndex()
          handleRemoveQuestion(deleteBlockId, deleteQuizIndex)
          //sessionStorage.setItem('assessmentId', response.assessmentId)
        }
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        notification.open('error', {
          title: e.response.data.errors?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    }
    setIsShowConfirmDeleteQuestion(false)
    doneLoading()
    setIsLoading(false)
  }

  const handleSaveCategory = async (block) => {
    setIsLoading(true)
    startLoading()

    try {
      var request = {
        categoryId: block.masterId,
        newCategoryId: block.id,
      }

      const response = await updateAssessmentConfigCategoryForm(request)

      if (response) {
        setFormSchema(response)
        setDeleteId()
        setIsNewBlock(false)
        updateQuestionBlock(block.id, 'isEditCategory', false)
        //updateQuestionBlock(block.id, 'masterId', null)

        //sessionStorage.setItem('assessmentId', response.assessmentId)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        notification.open('error', {
          title: e.response.data.errors?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  // const handleChangeInput = (blockId, qIndex, index, value) => {
  //   setQuestionBlocks((prev) =>
  //     prev.map((block) => {
  //       if (block.id !== blockId) return block
  //       block.questions[qIndex].radioAndCheckBoxOptions.splice(index, 1, value)
  //       var updatedQuestions = [...block.questions]
  //       return { ...block, questions: updatedQuestions }
  //     })
  //   )
  // }

  const handleChangeInput = (blockId, qIndex, optIndex, key, value) => {
    setQuestionBlocks((prev) =>
      prev.map((block) => {
        if (block.id !== blockId) return block

        const updatedOptions = block.questions[qIndex].radioAndCheckBoxOptions.map((opt, i) =>
          i === optIndex
            ? { ...opt, [key]: value } // อัพเดท field ที่ต้องการ
            : opt
        )

        const updatedQuestions = block.questions.map((q, i) =>
          i === qIndex ? { ...q, radioAndCheckBoxOptions: updatedOptions } : q
        )

        return { ...block, questions: updatedQuestions }
      })
    )
  }

  const handleAddQuestion = (blockId, qIndex) => {
  setQuestionBlocks((prev) =>
    prev.map((block) => {
      if (block.id !== blockId) return block

      const updatedQuestions = [...block.questions]
      // แทรกคำถามใหม่หลัง qIndex
      updatedQuestions.splice(qIndex + 1, 0, createEmptyQuestion())

      return { ...block, questions: updatedQuestions }
    })
  )
}

  const handleCopyQuestion = (blockId, qIndex) => {
    setQuestionBlocks((prev) =>
      prev.map((block) => {
        if (block.id !== blockId) return block
        var updatedQuestions = [...block.questions]
        var copyQuiz = { ...block.questions[qIndex], id: `quiz-${uuidv4()}`, isEdit: true }

        if (copyQuiz.questionType == 1 || copyQuiz.questionType == 2) {
          copyQuiz.radioAndCheckBoxOptions = copyQuiz.radioAndCheckBoxOptions
            .map((item) => {
              return {
                ...item,
                id: uuidv4(),
              }
            })
            .filter((i) => i.isDeleted != true)
        }
        console.log('copyQuiz', copyQuiz)
        updatedQuestions.splice(qIndex + 1, 0, copyQuiz)
        return { ...block, questions: updatedQuestions }
      })
    )
  }

  const handleRemoveQuestion = (blockId, qIndex) => {
    setQuestionBlocks((prev) =>
      prev.map((block) => {
        if (block.id !== blockId) return block
        var updatedQuestions = [...block.questions]
        updatedQuestions.splice(qIndex, 1)
        return { ...block, questions: updatedQuestions }
      })
    )
  }

  const getValueFromTreeOptions = (options, id) => {
    if (options?.length == 0) return null

    for (const opt of options) {
      if (opt.value === id) {
        return opt.label // เจอตัวที่ตรง
      }

      if (opt.children && opt.children.length > 0) {
        const found = getValueFromTreeOptions(opt.children, id)
        if (found) {
          return found
        }
      }
    }

    return null // ไม่เจอ
  }

  const renderChoices = (quiz, qIndex, blockId) => {
    const questionType = quiz?.questionType
    return (
      <div key={quiz.id} style={{ marginBottom: 8 }}>
        {questionType === 1 && (
          <Row>
            <RadioGroup
              //value={props.value}
              onChange={(value) => {
                // props.onChange(value)
                //onSelect(value)
              }}
            >
              {quiz.radioAndCheckBoxOptions?.map((item, index) =>
                item?.isDeleted ? (
                  <></>
                ) : (
                  <Row style={{ marginBottom: 5 }}>
                    <Col lg={1} md={2} sm={2} xs={2}>
                      <Radio key={item.id} value={item.id}></Radio>
                    </Col>

                    <Col lg={18} md={16} sm={16} xs={16}>
                      {quiz.isEdit ? (
                        <Input
                          value={item.value}
                          placeholder={'ระบุตัวเลือก'}
                          onChange={(value) => {
                            handleChangeInput(blockId, qIndex, index, 'value', value)
                          }}
                        />
                      ) : (
                        <p style={{ marginTop: 5 }}>{item.value}</p>
                      )}
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={4}>
                      {quiz.isEdit ? (
                        <NumberFormat
                          className={classNames('rs-input')}
                          thousandSeparator={true}
                          // decimalScale={2}
                          // fixedDecimalScale
                          value={item.score}
                          placeholder={'ระบุ' + formSchema?.form?.score?.label}
                          onValueChange={(value) => {
                            handleChangeInput(blockId, qIndex, index, 'score', value.floatValue)
                          }}
                        />
                      ) : (
                        <p>คะแนน : {item.score}</p>
                      )}
                    </Col>

                    <Col lg={1} md={2} sm={2} xs={2}>
                      {quiz.isEdit ? (
                        quiz.radioAndCheckBoxOptions.filter((i) => i.isDeleted != true).length >
                          1 && (
                          <IconButton
                            className="rs-btn-ghost-cancel"
                            icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                            onClick={() => {
                              var arr = quiz.radioAndCheckBoxOptions
                              arr[index].isDeleted = true
                              updateQuestionAndChoice(blockId, quiz.id, 'radioAndCheckBoxOptions', [
                                ...arr,
                              ])
                            }}
                          />
                        )
                      ) : (
                        <></>
                      )}
                    </Col>
                  </Row>
                )
              )}
            </RadioGroup>
            {quiz.isEdit ? (
              <IconButton
                icon={<Icon icon="plus" />}
                onClick={() =>
                  updateQuestionAndChoice(blockId, quiz.id, 'radioAndCheckBoxOptions', [
                    ...quiz.radioAndCheckBoxOptions,
                    {
                      id: `${uuidv4()}`,
                      label: null,
                      value: `เพิ่มตัวเลือก ${
                        quiz.radioAndCheckBoxOptions.filter((i) => i.isDeleted != true).length + 1
                      }`,
                      sequence:
                        quiz.radioAndCheckBoxOptions.filter((i) => i.isDeleted != true).length + 1,
                      score: 0,
                      questionId: null,
                    },
                  ])
                }
                className="rs-btn-input-group-save"
              />
            ) : (
              <></>
            )}
          </Row>
        )}

        {questionType === 2 && (
          <Row>
            <CheckboxGroup
              //value={props.value}
              onChange={(value) => {
                // props.onChange(value)
                //onSelect(value)
              }}
            >
              {quiz.radioAndCheckBoxOptions?.map((item, index) =>
                item?.isDeleted ? (
                  <></>
                ) : (
                  <Row style={{ marginBottom: 5 }}>
                    <Col lg={1} md={2} sm={2} xs={2}>
                      <Checkbox key={item.id} value={item.id}></Checkbox>
                    </Col>

                    <Col lg={18} md={16} sm={16} xs={16}>
                      {quiz.isEdit ? (
                        <Input
                          value={item.value}
                          placeholder={'ระบุตัวเลือก'}
                          onChange={(value) => {
                            handleChangeInput(blockId, qIndex, index, 'value', value)
                          }}
                        />
                      ) : (
                        <p style={{ marginTop: 5 }}>{item.value}</p>
                      )}
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={4}>
                      {quiz.isEdit ? (
                        <NumberFormat
                          className={classNames('rs-input')}
                          thousandSeparator={true}
                          // decimalScale={2}
                          // fixedDecimalScale
                          value={item.score}
                          placeholder={'ระบุ' + formSchema?.form?.score?.label}
                          onValueChange={(value) => {
                            handleChangeInput(blockId, qIndex, index, 'score', value.floatValue)
                          }}
                        />
                      ) : (
                        <p>คะแนน : {item.score}</p>
                      )}
                    </Col>

                    <Col lg={1} md={2} sm={2} xs={2}>
                      {quiz.isEdit ? (
                        <IconButton
                          className="rs-btn-ghost-cancel"
                          icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                          onClick={() => {
                            var arr = quiz.radioAndCheckBoxOptions
                            arr[index].isDeleted = true
                            updateQuestionAndChoice(blockId, quiz.id, 'radioAndCheckBoxOptions', [
                              ...arr,
                            ])
                          }}
                        />
                      ) : (
                        <></>
                      )}
                    </Col>
                  </Row>
                )
              )}
            </CheckboxGroup>
            {quiz.isEdit ? (
              <IconButton
                icon={<Icon icon="plus" />}
                onClick={() =>
                  updateQuestionAndChoice(blockId, quiz.id, 'radioAndCheckBoxOptions', [
                    ...quiz.radioAndCheckBoxOptions,
                    {
                      id: `${uuidv4()}`,
                      label: null,
                      value: `เพิ่มตัวเลือก ${quiz.radioAndCheckBoxOptions.length + 1}`,
                      sequence: 1,
                      score: 0,
                      questionId: null,
                    },
                  ])
                }
                className="rs-btn-input-group-save"
              />
            ) : (
              <></>
            )}
          </Row>
        )}

        {questionType === 3 && (
          <Row>
            <Col lg={20} md={20} sm={20} xs={20}>
              <Input componentClass="textarea" placeholder="ตัวอย่างช่องกรอกคำตอบยาว" />
            </Col>
            <Col lg={4} md={4} sm={4} xs={4}>
              {quiz.isEdit ? (
                <>
                  {/* <ControlLabel>
                    {formSchema?.form?.score?.label || 'คะแนน'}
                  </ControlLabel> */}
                  <NumberFormat
                    className={classNames('rs-input')}
                    thousandSeparator={true}
                    // decimalScale={2}
                    // fixedDecimalScale
                    value={quiz.score}
                    placeholder={'ระบุ' + formSchema?.form?.score?.label}
                    onValueChange={(value) => {
                      updateQuestionAndChoice(blockId, quiz.id, 'score', value.floatValue)
                    }}
                  />
                </>
              ) : (
                <p>คะแนน : {quiz.score}</p>
              )}
            </Col>
          </Row>
        )}

        {questionType === 4 && (
          <Row>
            <Col lg={20} md={20} sm={20} xs={20}>
              <Input placeholder="ตัวอย่างช่องกรอกคำตอบสั้น" />
            </Col>
            <Col lg={4} md={4} sm={4} xs={4}>
              {quiz.isEdit ? (
                <NumberFormat
                  className={classNames('rs-input')}
                  thousandSeparator={true}
                  // decimalScale={2}
                  // fixedDecimalScale
                  value={quiz.score}
                  placeholder={'ระบุ' + formSchema?.form?.score?.label}
                  onValueChange={(value) => {
                    updateQuestionAndChoice(blockId, quiz.id, 'score', value.floatValue)
                  }}
                />
              ) : (
                <p>คะแนน : {quiz.score}</p>
              )}
            </Col>
          </Row>
        )}

        {questionType === 5 && (
          <Row>
            <Col lg={20} md={20} sm={20} xs={20}>
              <NumberFormat
                className={classNames('rs-input')}
                thousandSeparator={true}
                decimalScale={2}
                fixedDecimalScale
                placeholder="ตัวอย่างช่องกรอกตัวเลข"
              />
            </Col>
            <Col lg={4} md={4} sm={4} xs={4}>
              {quiz.isEdit ? (
                <NumberFormat
                  className={classNames('rs-input')}
                  thousandSeparator={true}
                  // decimalScale={2}
                  // fixedDecimalScale
                  value={quiz.score}
                  placeholder={'ระบุ' + formSchema?.form?.score?.label}
                  onValueChange={(value) => {
                    updateQuestionAndChoice(blockId, quiz.id, 'score', value.floatValue)
                  }}
                />
              ) : (
                <p>คะแนน : {quiz.score}</p>
              )}
            </Col>
          </Row>
        )}

        {questionType === 6 && (
          <Row>
            {quiz.isEdit ? (
              <SelectPicker
                placeholder="จำนวนดาว"
                style={{ width: 150 }}
                searchable={false}
                cleanable={false}
                data={ratingOptions || []}
                onChange={(value) => {
                  updateQuestionAndChoice(blockId, quiz.id, 'ratingMaximum', value)
                }}
                defaultValue={quiz.ratingMaximum || 5}
              />
            ) : (
              <></>
            )}
            <br />
            <Row style={{ textAlign: 'center' }}>
              <Col lg={20} md={20} sm={20} xs={20}>
                <Rate
                  defaultValue={quiz.ratingMaximum / 2}
                  max={quiz.ratingMaximum || 5}
                  classPrefix="rs-rate rs-rate-size-xl"
                />
              </Col>

              <Col lg={4} md={4} sm={4} xs={4}>
                {quiz.isEdit ? (
                  <NumberFormat
                    className={classNames('rs-input')}
                    thousandSeparator={true}
                    // decimalScale={2}
                    // fixedDecimalScale
                    value={quiz.score}
                    placeholder={'ระบุ' + formSchema?.form?.score?.label}
                    onValueChange={(value) => {
                      updateQuestionAndChoice(blockId, quiz.id, 'score', value.floatValue)
                    }}
                  />
                ) : (
                  <p>คะแนน : {quiz.score}</p>
                )}
              </Col>
            </Row>
          </Row>
        )}

        {questionType === 7 && (
          <Row>
            <Col lg={20} md={20} sm={20} xs={20}>
              <Cascader
                block
                menuWidth={200}
                data={location}
                placeholder={'ตัวอย่างพื้นที่แบบตัวเลือกเดี่ยว'}
              />
            </Col>

            <Col lg={4} md={4} sm={4} xs={4}>
              {quiz.isEdit ? (
                <NumberFormat
                  className={classNames('rs-input')}
                  thousandSeparator={true}
                  // decimalScale={2}
                  // fixedDecimalScale
                  value={quiz.score}
                  placeholder={'ระบุ' + formSchema?.form?.score?.label}
                  onValueChange={(value) => {
                    updateQuestionAndChoice(blockId, quiz.id, 'score', value.floatValue)
                  }}
                />
              ) : (
                <p>คะแนน : {quiz.score}</p>
              )}
            </Col>
          </Row>
        )}

        {questionType === 8 && (
          <Row>
            <Col lg={20} md={20} sm={20} xs={20}>
              <MultiCascader
                //size="lg"
                block
                menuWidth={200}
                data={location}
                placeholder={'ตัวอย่างพื้นที่แบบหลายตัวเลือก'}
                renderValue={(value, selectedItems) => {
                  return <span>{selectedItems.map((item) => item.label).join(' , ')}</span>
                }}
              />
            </Col>

            <Col lg={4} md={4} sm={4} xs={4}>
              {quiz.isEdit ? (
                <NumberFormat
                  className={classNames('rs-input')}
                  thousandSeparator={true}
                  // decimalScale={2}
                  // fixedDecimalScale
                  value={quiz.score}
                  placeholder={'ระบุ' + formSchema?.form?.score?.label}
                  onValueChange={(value) => {
                    updateQuestionAndChoice(blockId, quiz.id, 'score', value.floatValue)
                  }}
                />
              ) : (
                <p>คะแนน : {quiz.score}</p>
              )}
            </Col>
          </Row>
        )}
        {questionType === 9 && (
          <Row>
            <RadioGroup
              //value={props.value}
              onChange={(value) => {
                // props.onChange(value)
                //onSelect(value)
              }}
            >
              {quiz.radioAndCheckBoxOptions?.map((item, index) =>
                item?.isDeleted ? (
                  <></>
                ) : (
                  <Row style={{ marginBottom: 5 }}>
                    <Col lg={1} md={2} sm={2} xs={2}>
                      {/* <Radio key={item.id} value={item.id}></Radio> */}
                    </Col>

                    <Col lg={18} md={16} sm={16} xs={16}>
                      {quiz.isEdit ? (
                        <Input
                          value={item.value}
                          placeholder={'ระบุตัวเลือก'}
                          onChange={(value) => {
                            handleChangeInput(blockId, qIndex, index, 'value', value)
                          }}
                        />
                      ) : (
                        <p style={{ marginTop: 5 }}>{item.value}</p>
                      )}
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={4}>
                      {quiz.isEdit ? (
                        <NumberFormat
                          className={classNames('rs-input')}
                          thousandSeparator={true}
                          // decimalScale={2}
                          // fixedDecimalScale
                          value={item.score}
                          placeholder={'ระบุ' + formSchema?.form?.score?.label}
                          onValueChange={(value) => {
                            handleChangeInput(blockId, qIndex, index, 'score', value.floatValue)
                          }}
                        />
                      ) : (
                        <p>คะแนน : {item.score}</p>
                      )}
                    </Col>

                    <Col lg={1} md={2} sm={2} xs={2}>
                      {quiz.isEdit ? (
                        quiz.radioAndCheckBoxOptions.filter((i) => i.isDeleted != true).length >
                          1 && (
                          <IconButton
                            className="rs-btn-ghost-cancel"
                            icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                            onClick={() => {
                              var arr = quiz.radioAndCheckBoxOptions
                              arr[index].isDeleted = true
                              updateQuestionAndChoice(blockId, quiz.id, 'radioAndCheckBoxOptions', [
                                ...arr,
                              ])
                            }}
                          />
                        )
                      ) : (
                        <></>
                      )}
                    </Col>
                  </Row>
                )
              )}
            </RadioGroup>
            {quiz.isEdit ? (
              <IconButton
                icon={<Icon icon="plus" />}
                onClick={() =>
                  updateQuestionAndChoice(blockId, quiz.id, 'radioAndCheckBoxOptions', [
                    ...quiz.radioAndCheckBoxOptions,
                    {
                      id: `${uuidv4()}`,
                      label: null,
                      value: `เพิ่มตัวเลือก ${
                        quiz.radioAndCheckBoxOptions.filter((i) => i.isDeleted != true).length + 1
                      }`,
                      sequence:
                        quiz.radioAndCheckBoxOptions.filter((i) => i.isDeleted != true).length + 1,
                      score: 0,
                      questionId: null,
                    },
                  ])
                }
                className="rs-btn-input-group-save"
              />
            ) : (
              <></>
            )}
          </Row>
        )}
      </div>
    )
  }

  const handleAddBlock = (index) => {
    const newBlock = createEmptyBlock()
    if (typeof index === 'number') {
      //แทรกที่ index
      setQuestionBlocks((prev) => [...prev.slice(0, index + 1), newBlock, ...prev.slice(index + 1)])
    } else {
      setQuestionBlocks((prev) => [...prev, newBlock])
    }
  }

  const handleRemoveBlock = (id) => {
    setQuestionBlocks((prev) => prev.filter((b) => b.id !== id))
  }

  const handleRemoveBlockByIndex = (index) => {
    setQuestionBlocks((prev) => prev.filter((_, i) => i !== index))
  }

  const updateBlock = (blockId, field, value) => {
    setQuestionBlocks((prev) =>
      prev.map((b) => {
        if (b.id !== blockId) {
          return b
        }
        return { ...b, [field]: value }
      })
    )
  }

  const updateQuestionAndChoice = (blockId, quizId, field, value) => {
    setQuestionBlocks((prev) =>
      prev.map((b) => {
        if (b.id !== blockId) return b

        // อัปเดต questions ภายใน block ที่ตรง id
        const updatedQuestions = b.questions.map((qz) => {
          if (qz.id !== quizId) return qz
          return {
            ...qz,
            [field]: value,
          }
        })

        return {
          ...b,
          questions: updatedQuestions,
        }

        //return { ...b, [field]: value }
      })
    )
  }

  const resetQuestionAndChoice = (blockId, quizId) => {
    // ดึง block master ที่ตรงกับ blockId
    const masterBlock = formSchema?.form?.assessmentCategory?.find(b => b.id === blockId)
    if (!masterBlock) return

    // ดึง question master ที่ตรงกับ quizId
    const masterQuestion = masterBlock.questions?.find(q => q.id === quizId)
    if (!masterQuestion) return

    setQuestionBlocks((prev) =>
      prev.map((b) => {
        if (b.id !== blockId) return b

        // แทน question ที่ตรง id ด้วย master question
        const updatedQuestions = b.questions.map((qz) => {
          if (qz.id !== quizId) return qz
          return {
            ...masterQuestion, // เอาของ master มาแทน
          }
        })

        return {
          ...b,
          questions: updatedQuestions,
        }
      })
    )
  }

  const updateQuestionBlock = (blockId, field, value) => {
    setQuestionBlocks((prev) =>
      prev.map((b) => {
        if (b.id !== blockId) return b

        return { ...b, [field]: value }
      })
    )
  }

  const filterByCategoryType = (nodes, type) => {
    return nodes
      .map((node) => {
        // กรอง children ก่อน
        const filteredChildren = filterByCategoryType(node.children || [], type)

        // ถ้า node นี้ตรง type หรือมีลูกที่ตรง type ให้ return
        if (node.categoryType === type || filteredChildren.length > 0) {
          return {
            ...node,
            children: filteredChildren.filter(
              (c) => c.categoryType === type || c.children.length > 0
            ),
          }
        }

        return null
      })
      .filter((node) => node !== null)
  }

  const handleSubmit = (blockId, quizId) => {
    console.log('questionBlocks:', questionBlocks)

    const data = cloneDeep(questionBlocks)

    var question
    var categoryId
    var isEditCategory
    var isNew

    data.map((b) => {
      if (b.id == blockId) {
        isEditCategory = b.isEditCategory
        isNew = b.isNew

        b.questions.map((qz, index) => {
          if (qz.id == quizId) {
            var _quizId = quizId
            if (quizId.indexOf('quiz-') != -1) {
              _quizId = quizId.replace('quiz-', '')
            }

            question = { ...qz, id: _quizId, sequence: index + 1 }
            categoryId = b.id
          }
        })
      }
    })

    if (!categoryId) {
      notification.open('error', {
        title: 'กรุณาเลือกหมวดหมู่แบบสอบถาม ก่อนบันทึกคำถาม',
        duration: 5000,
      })
      return
    }

    if (!isNew && isEditCategory) {
      notification.open('error', {
        title: 'กรุณาบันทึกหมวดหมู่แบบสอบถาม ก่อนบันทึกคำถาม',
        duration: 5000,
      })
      return
    }

    // สร้าง object ตาม format ที่ต้องการ
    const formData = {
      question: question,
      categoryId: categoryId,
      assessmentId: assessmentId,
    }
    console.log('📦 ข้อมูลฟอร์ม:', formData)

    handleSaveQuestion(formData, blockId, quizId)
  }

  const handleSubmitHeader = () => {
    var _startDate = startDate
    var _endDate = endDate

    if (typeof _startDate === 'string') {
      _startDate = moment(_startDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
    }

    if (typeof _endDate === 'string') {
      _endDate = moment(_endDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
    }

    var request = {
      assessmentId: assessmentId || null,
      assessmentName: assessmentName,
      assessmentShowName: assessmentShowName,
      assessmentDescription: assessmentDescription,
      startDate: _startDate ? moment(_startDate).format(DATE_FORMAT) : null,
      endDate: _endDate ? moment(_endDate).format(DATE_FORMAT) : null,
      budgetStart: budgetStart || 0,
      budgetEnd: budgetEnd || 0,
      status: statusVal || 0,
      assessmentFor: assessmentForVal || 0,
      categoryId: categoryTypeSelected || 0,
    }

    console.log('request', request)

    handleSaveHeader(request)
  }

  const handleEditHeader = () => {
    setHeaderValueFromSchema()
    setIsEditHeader(true)
  }

  const ValidateVal = () => {
    if (isEmpty(assessmentName)) {
      notification.open('error', {
        title: 'กรุณากรอก' + `${formSchema?.form?.assessmentName?.label || 'ชื่อชุดแบบประเมิน'}`,
        duration: 5000,
      })
      return
    }

    setIsShowConfirmSaveHeader(true)
  }

  const renderSelectCategoryType = () => {
    return (
      <RadioGroup
        //value={props.value}
        onChange={(value) => {
          setCategoryTypeSelected(value)
          // props.onChange(value)
          //onSelect(value)
        }}
        inline
      >
        {formSchema?.form?.categoryType?.options?.map((item, index) => (
          <Row style={{ marginBottom: 5 }}>
            <Col lg={24} md={24} sm={24} xs={24}>
              <Radio key={item.value} value={item.value}>
                {item.label}
              </Radio>
            </Col>
          </Row>
        ))}
      </RadioGroup>
    )
  }

  return (
    <>
      <Panel shaded defaultExpanded header={' '} bordered>
        <Row style={{ marginBottom: 10 }}>
          <Col lg={4}></Col>
          <Col lg={16}>
            {isEditHeader && !disabledForm ? (
              <>
                {formSchema?.form?.assessmentName?.label}
                <Input
                  value={assessmentName}
                  placeholder={formSchema?.form?.assessmentName?.label}
                  onChange={(value) => {
                    setAssessmentName(value)
                  }}
                />
                <ShowLimitLength textLength={assessmentName?.length || 0} maxLength={255} />
              </>
            ) : (
              <>
                <b style={{color: '#2da888'}}>{formSchema?.form?.assessmentName?.label}</b>
                <p>{formSchema?.form?.assessmentName?.value || '-'}</p>
              </>
            )}
          </Col>
        </Row>

        <Row style={{ marginBottom: 10 }}>
          <Col lg={4}></Col>
          <Col lg={16}>
            {isEditHeader && !disabledForm ? (
              <>
                {formSchema?.form?.assessmentShowName?.label}
                <Input
                  value={assessmentShowName}
                  placeholder={formSchema?.form?.assessmentShowName?.label}
                  onChange={(value) => {
                    setAssessmentShowName(value)
                  }}
                />
                <ShowLimitLength textLength={assessmentShowName?.length || 0} maxLength={255} />
              </>
            ) : (
              <>
                <b style={{color: '#2da888'}}>{formSchema?.form?.assessmentShowName?.label}</b>
                <p>{formSchema?.form?.assessmentShowName?.value || '-'}</p>
              </>
            )}
          </Col>
        </Row>

        <Row style={{ marginBottom: 10 }}>
          <Col lg={4}></Col>
          <Col lg={16}>
            {isEditHeader && !disabledForm ? (
              <>
                {formSchema?.form?.assessmentDescription?.label}
                <Input
                  componentClass="textarea"
                  value={assessmentDescription}
                  placeholder={formSchema?.form?.assessmentDescription?.label}
                  onChange={(value) => {
                    setAssessmentDescription(value)
                  }}
                />
                <ShowLimitLength textLength={assessmentDescription?.length || 0} maxLength={4000} />
              </>
            ) : (
              <>
                <b style={{color: '#2da888'}}>{formSchema?.form?.assessmentDescription?.label}</b>
                <p>{formSchema?.form?.assessmentDescription?.value || '-'}</p>
              </>
            )}
          </Col>
        </Row>

        <Row style={{ marginBottom: 10 }}>
          <Col lg={4}></Col>
          <Col lg={8}>
            {isEditHeader && !disabledForm ? (
              <>
                {formSchema?.form?.startDate?.label}
                <DatePickerCustom
                  placement="auto"
                  value={startDate ? moment(startDate, 'DD/MM/YYYY').toDate() : null}
                  onChange={(value) => setStartDate(value)}
                  disabledDate={(date) => endDate && moment(endDate, 'DD/MM/YYYY').isBefore(date)}
                />
              </>
            ) : (
              <>
                <b style={{color: '#2da888'}}>{formSchema?.form?.startDate?.label}</b>
                <p>{formSchema?.form?.startDate?.value || '-'}</p>
              </>
            )}
          </Col>
          <Col lg={8}>
            {isEditHeader ? (
              <>
                {formSchema?.form?.endDate?.label}
                <DatePickerCustom
                  placement="auto"
                  value={endDate ? moment(endDate, 'DD/MM/YYYY').toDate() : null}
                  onChange={(value) => setEndDate(value)}
                  disabledDate={(date) =>
                    startDate && moment(startDate, 'DD/MM/YYYY').isAfter(date)
                  }
                />
              </>
            ) : (
              <>
                <b style={{color: '#2da888'}}>{formSchema?.form?.endDate?.label}</b>
                <p>{formSchema?.form?.endDate?.value || '-'}</p>
              </>
            )}
          </Col>
        </Row>

        <Row style={{ marginBottom: 10 }}>
          <Col lg={4}></Col>
          <Col lg={8}>
            {isEditHeader && !disabledForm ? (
              <>
                {formSchema?.form?.budgetStart?.label}
                <NumberFormat
                  className={classNames('rs-input')}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale
                  value={budgetStart}
                  onValueChange={(value) => {
                    setBudgetStart(value.floatValue)
                  }}
                  placeholder="0.00"
                />
              </>
            ) : (
              <>
                <b style={{color: '#2da888'}}>{formSchema?.form?.budgetStart?.label}</b>
                <p>{budgetFormat(formSchema?.form?.budgetStart?.value) || '-'}</p>
              </>
            )}
          </Col>
          <Col lg={8}>
            {isEditHeader && !disabledForm ? (
              <>
                {formSchema?.form?.budgetEnd?.label}
                <NumberFormat
                  className={classNames('rs-input')}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale
                  value={budgetEnd}
                  onValueChange={(value) => {
                    setBudgetEnd(value.floatValue)
                  }}
                  placeholder="0.00"
                />
              </>
            ) : (
              <>
                <b style={{color: '#2da888'}}>{formSchema?.form?.budgetEnd?.label}</b>
                <p>{budgetFormat(formSchema?.form?.budgetEnd?.value) || '-'}</p>
              </>
            )}
          </Col>
        </Row>

        <Row style={{ marginBottom: 10 }}>
          <Col lg={4}></Col>
          <Col lg={8}>
            {isEditHeader ? (
              <>
                {formSchema?.form?.assessmentStatus?.label}
                <SelectPicker
                  searchable={false}
                  cleanable={false}
                  value={statusVal}
                  data={formSchema?.form?.assessmentStatus?.options}
                  block
                  placeholder={formSchema?.form?.assessmentStatus?.label}
                  onChange={(value) => setStatusVal(value)}
                />
              </>
            ) : (
              <>
                <b style={{color: '#2da888'}}>{formSchema?.form?.assessmentStatus?.label}</b>
                <p>
                  {formSchema?.form?.assessmentStatus?.value
                    ? getValueFromOptions(
                        formSchema?.form?.assessmentStatus?.options,
                        formSchema?.form?.assessmentStatus?.value
                      )
                    : '-'}
                </p>
              </>
            )}
          </Col>
          {!isDep6 && 
          <Col lg={8}>
            {isEditHeader && !disabledForm ? (
              <>
                {formSchema?.form?.assessmentFor?.label}
                <SelectPicker
                  searchable={false}
                  value={assessmentForVal}
                  data={formSchema?.form?.assessmentFor?.options}
                  block
                  placeholder={formSchema?.form?.assessmentFor?.label}
                  onChange={(value) => setAssessmentForVal(value)}
                />
              </>
            ) : (
              <>
                <b style={{color: '#2da888'}}>{formSchema?.form?.assessmentFor?.label}</b>
                <p>
                  {formSchema?.form?.assessmentFor?.value
                    ? getValueFromOptions(
                        formSchema?.form?.assessmentFor?.options,
                        formSchema?.form?.assessmentFor?.value
                      )
                    : '-'}
                </p>
              </>
            )}
          </Col>}
        </Row>

        <Row style={{ marginTop: 20 }}>
          <Col lg={4}></Col>
          {isEditHeader ? (
            <Col lg={20} md={20} sm={20} xs={20}>
              <SaveButton
                onClick={() => ValidateVal()}
                style={{ marginRight: 10, marginBottom: 10 }}
              >
                บันทึก
              </SaveButton>
              <CancelButton onClick={() => setIsEditHeader(false)}>ยกเลิก</CancelButton>
            </Col>
          ) : (
            <EditButton onClick={handleEditHeader} style={{ marginRight: 10, marginBottom: 10 }}>
              แก้ไข
            </EditButton>
          )}
        </Row>

        <br />

        {questionBlocks.map((block, index) => (
          <Panel bordered key={block.id} style={{ marginBottom: 16 }}>
            <ControlLabel>
              {formSchema?.form?.assessmentType?.label || 'หมวดหมู่แบบสอบถาม'}
            </ControlLabel>

            <Row style={{ marginBottom: 10 }}>
              <Col lg={18} md={16} sm={24} xs={24}>
                {block.isNew || block.isEditCategory ? (
                  <TreePicker
                    defaultExpandAll
                    block
                    menuWidth={180}
                    data={
                      isAddNew
                        ? filterByCategoryType(
                            formSchema?.form?.assessmentTreeType?.options,
                            categoryTypeSelected
                          )
                        : formSchema?.form?.assessmentTreeType?.options
                    }
                    value={block.id}
                    onChange={(value) => {
                      updateQuestionBlock(block.id, 'id', value)
                    }}
                    disabledItemValues={
                      questionBlocks.length > 0 && questionBlocks?.map((i) => i.id)
                    }
                    placeholder={formSchema?.form?.assessmentTreeType?.label}
                  />
                ) : (
                  <span>
                    {getValueFromTreeOptions(
                      formSchema?.form?.assessmentTreeType?.options,
                      block.id
                    )}
                  </span>
                )}
              </Col>

              {!disabledForm && (
                <Col lg={6} md={8} sm={24} xs={24} style={{ textAlign: 'end' }}>
                  {block.isNew ? (
                    <>
                      <IconButton
                        onClick={() => {
                          setIsShowConfirmDeleteCategory(true)
                          setDeleteId(block.id)
                          setDeleteIndex(index)
                          setIsNewBlock(true)
                        }}
                        className="rs-btn-ghost-cancel"
                        appearance="ghost"
                        icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                        style={{ marginRight: 10 }}
                      >
                        ลบ
                      </IconButton>
                      <IconButton
                        onClick={() => handleAddBlock(index)}
                        className="rs-btn-save"
                        appearance="ghost"
                        icon={<Icon icon="plus" />}
                      >
                        เพิ่ม
                      </IconButton>
                    </>
                  ) : block.isEditCategory ? (
                    <>
                      <IconButton
                        onClick={() => handleSaveCategory(block)}
                        className="rs-btn-ghost-save"
                        appearance="ghost"
                        icon={<Icon icon="save" className="bt-gost-icon-radius" />}
                        style={{ marginRight: 10 }}
                      >
                        บันทึก
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          updateQuestionBlock(block.id, 'isEditCategory', false)
                          updateQuestionBlock(block.id, 'id', block.masterId)
                        }}
                        className="rs-btn-ghost-cancel"
                        appearance="ghost"
                        icon={<Icon icon="close" className="bt-gost-icon-radius-cancel" />}
                      >
                        ยกเลิก
                      </IconButton>
                    </>
                  ) : (
                    <>
                      <IconButton
                        onClick={() => {
                          updateQuestionBlock(block.id, 'isEditCategory', true)
                          updateQuestionBlock(block.id, 'masterId', block.id)
                        }}
                        className="rs-btn-ghost-edit"
                        appearance="ghost"
                        icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                        style={{ marginRight: 10, marginBottom: 10 }}
                      >
                        แก้ไข
                      </IconButton>

                      <IconButton
                        onClick={() => {
                          setIsShowConfirmDeleteCategory(true)
                          setDeleteId(block.id)
                        }}
                        className="rs-btn-ghost-cancel"
                        appearance="ghost"
                        icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                        style={{ marginRight: 10, marginBottom: 10 }}
                      >
                        ลบ
                      </IconButton>
                      <IconButton
                        onClick={() => handleAddBlock(index)}
                        className="rs-btn-save"
                        appearance="ghost"
                        icon={<Icon icon="plus" />}
                        style={{ marginBottom: 10 }}
                      >
                        เพิ่ม
                      </IconButton>
                    </>
                  )}
                </Col>
              )}
            </Row>

            {block?.questions?.map((quiz, qIndex) => (
              <Panel bordered style={{ marginBottom: 10 }}>
                <Row style={{ marginBottom: 10, marginTop: 10 }}>
                  <Col lg={quiz.isEdit ? 16 : 24} md={14} sm={24} xs={24} style={{ marginBottom: 10 }}>
                    {quiz.isEdit ? (
                      <>
                        <ControlLabel>
                          {formSchema?.form?.questionName?.label || 'คำถาม'}
                        </ControlLabel>
                        <Input
                          placeholder={'ระบุ' + formSchema?.form?.questionName?.label || 'คำถาม'}
                          value={quiz.questionName}
                          onChange={(value) =>
                            updateQuestionAndChoice(block.id, quiz.id, 'questionName', value)
                          }
                        />
                      </>
                    ) : (
                      <p>{quiz.questionName}</p>
                    )}
                  </Col>
                  <Col lg={8} md={10} sm={24} xs={24}>
                    {quiz.isEdit ? (
                      <>
                        <ControlLabel>
                          {formSchema?.form?.questionType?.label || 'ประเภทคำถาม'}
                        </ControlLabel>
                        <SelectPicker
                          searchable={false}
                          value={quiz.questionType}
                          data={formSchema?.form?.questionType?.options}
                          onChange={(value) =>
                            updateQuestionAndChoice(block.id, quiz.id, 'questionType', value)
                          }
                          block
                          placeholder={'ระบุ' + formSchema?.form?.questionType?.label}
                          renderMenuItem={(label, item) => (
                            <>
                              <Icon icon={item.icon} /> <span>{label}</span>
                            </>
                          )}
                          renderValue={(_, item) => (
                            <>
                              <Icon icon={item.icon} /> <span>{item.label}</span>
                            </>
                          )}
                        />
                      </>
                    ) : (
                      <p style={{ textAlign: 'end' }}>
                        {/* {getValueFromOptions(
                          formSchema?.form?.questionType?.options,
                          quiz.questionType
                        )} */}
                      </p>
                    )}
                  </Col>
                </Row>

                {renderChoices(quiz, qIndex, block.id)}

                {isDep6 && (
                  <div>
                    <Row>
                      <br />
                      <Col lg={12} md={12} sm={24} xs={24} style={{ marginBottom: 10 }}>
                        {quiz.isEdit ? (
                          <>
                            <ControlLabel>
                              {formSchema?.form?.preposition?.label || 'ช่วงของการประเมินผล'}
                            </ControlLabel>
                            <SelectPicker
                              searchable={false}
                              value={quiz.preposition}
                              data={formSchema?.form?.preposition?.options}
                              onChange={(value) =>
                                updateQuestionAndChoice(block.id, quiz.id, 'preposition', value)
                              }
                              block
                              placeholder={'ระบุ' + formSchema?.form?.preposition?.label}
                            />
                          </>
                        ) : (
                          <p>
                            {formSchema?.form?.preposition?.label || 'ช่วงของการประเมินผล'}
                            &nbsp;:&nbsp;
                            {getValueFromOptions(
                              formSchema?.form?.preposition?.options,
                              quiz.preposition
                            )}
                          </p>
                        )}
                      </Col>

                      <Col lg={12} md={12} sm={24} xs={24} style={{ marginBottom: 10 }}>
                        {quiz.isEdit ? (
                          <>
                            <ControlLabel>
                              {formSchema?.form?.component?.label || 'องค์ประกอบของการประเมินผล'}
                            </ControlLabel>
                            <SelectPicker
                              searchable={false}
                              value={quiz.component}
                              data={formSchema?.form?.component?.options}
                              onChange={(value) =>
                                updateQuestionAndChoice(block.id, quiz.id, 'component', value)
                              }
                              block
                              placeholder={'ระบุ' + formSchema?.form?.component?.label}
                            />
                          </>
                        ) : (
                          <p>
                            {formSchema?.form?.component?.label || 'ช่วงของการประเมินผล'}
                            &nbsp;:&nbsp;
                            {getValueFromOptions(
                              formSchema?.form?.component?.options,
                              quiz.component
                            )}
                          </p>
                        )}
                      </Col>
                    </Row>

                    <Row>
                      <ControlLabel>
                        {formSchema?.form?.description?.label ||
                          'คำอธิบายเพิ่มเติมหรือข้อมูลประกอบการพิจารณาและประเมินผล'}
                      </ControlLabel>
                      {quiz.isEdit ? (
                        <>
                          <Input
                            componentClass="textarea"
                            placeholder={'ระบุ' + formSchema?.form?.description?.label}
                            value={quiz.description}
                            onChange={(value) => {
                              updateQuestionAndChoice(block.id, quiz.id, 'description', value)
                            }}
                          />
                          <ShowLimitLength
                            textLength={quiz.description?.length || 0}
                            maxLength={4000}
                          />
                        </>
                      ) : (
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;{quiz.description}</p>
                      )}
                    </Row>
                  </div>
                )}

                <Row style={{ marginTop: 5 }}>
                  {!isDep6 && (
                    <div style={{ float: 'inline-start', marginRight: 5 }}>
                      {quiz.isEdit ? (
                        <>
                          <ControlLabel>
                            {formSchema?.form?.dimensionWeight?.label || 'weight ตามมิติ'}
                          </ControlLabel>
                          <NumberFormat
                            className={classNames('rs-input')}
                            thousandSeparator={true}
                            // decimalScale={2}
                            // fixedDecimalScale
                            placeholder={'ระบุ ' + formSchema?.form?.dimensionWeight?.label}
                            value={quiz.dimensionWeight}
                            onValueChange={(value) => {
                              updateQuestionAndChoice(
                                block.id,
                                quiz.id,
                                'dimensionWeight',
                                value.floatValue
                              )
                            }}
                          />
                        </>
                      ) : (
                        <p style={{ marginTop: 15 }}>
                          {formSchema?.form?.dimensionWeight?.label || 'weight ตามมิติ'} :{' '}
                          {quiz.dimensionWeight}
                        </p>
                      )}
                    </div>
                  )}
                  <div style={{ float: 'inline-start', marginRight: 5  }}>
                    {quiz.isEdit ? (
                      <>
                        <ControlLabel>
                          {isDep6
                            ? 'weight'
                            : formSchema?.form?.ratioWeight?.label || 'weight ตามส่วน'}
                        </ControlLabel>
                        <NumberFormat
                          className={classNames('rs-input')}
                          thousandSeparator={true}
                          // decimalScale={2}
                          // fixedDecimalScale
                          placeholder={'ระบุ ' + formSchema?.form?.ratioWeight?.label}
                          value={quiz.ratioWeight}
                          onValueChange={(value) => {
                            updateQuestionAndChoice(
                              block.id,
                              quiz.id,
                              'ratioWeight',
                              value.floatValue
                            )
                          }}
                        />
                      </>
                    ) : (
                      <p style={{ marginTop: 15 }}>
                        {isDep6
                          ? 'weight'
                          : formSchema?.form?.ratioWeight?.label || 'weight ตามส่วน'}{' '}
                        : {quiz.ratioWeight}
                      </p>
                    )}
                  </div>
                </Row>
                
                {categoryTypeSelected == 2 &&
                <Row style={{ marginTop: 5 }}>
                  {quiz.isEdit ? (
                    <>
                      <ControlLabel>
                        {formSchema?.form?.masterQuestion?.label || 'master คำถาม'}
                      </ControlLabel>
                      <SelectPicker
                        searchable={true}
                        value={quiz.assessmentQuestionMasterMappingId}
                        data={formSchema?.form?.masterQuestion?.options}
                        onChange={(value) =>
                          updateQuestionAndChoice(block.id, quiz.id, 'assessmentQuestionMasterMappingId', value)
                        }
                        block
                        placeholder={'ระบุ' + formSchema?.form?.masterQuestion?.label}
                      />
                    </>
                  ) : (
                    <p style={{ marginTop: 15 }}>
                      {formSchema?.form?.masterQuestion?.label || 'master คำถาม'}{' '}
                      : {getValueFromOptions(
                              formSchema?.form?.masterQuestion?.options,
                              quiz.assessmentQuestionMasterMappingId
                            )}
                    </p>
                  )}
                </Row>}
                
                <hr />
                <Row>
                  <div style={{ textAlign: 'end' }}>
                    {quiz.isEdit ? (
                      <Toggle
                        style={{ marginRight: 10 }}
                        size="lg"
                        checkedChildren="จำเป็น"
                        unCheckedChildren="ไม่จำเป็น"
                        checked={quiz.required}
                        onChange={(checked) =>
                          updateQuestionAndChoice(block.id, quiz.id, 'required', checked)
                        }
                      />
                    ) : (
                      <b style={{ color: '#2da888', marginRight: 5 }}>
                        {quiz.required ? 'จำเป็น' : 'ไม่จำเป็น'}
                      </b>
                    )}

                    {!disabledForm && (
                      <>
                        <IconButton
                          onClick={() => handleCopyQuestion(block.id, qIndex)}
                          className="rs-btn-info"
                          appearance="ghost"
                          icon={<Icon icon="copy" />}
                          style={{ marginRight: 10 }}
                        >
                          คัดลอกคำถาม
                        </IconButton>
                        <IconButton
                          onClick={() => handleAddQuestion(block.id, qIndex)}
                          className="rs-btn-save"
                          appearance="ghost"
                          icon={<Icon icon="plus" />}
                          style={{ marginRight: 10 }}
                        >
                          เพิ่มคำถาม
                        </IconButton>
                        {block?.questions.length != 1 && (
                          <IconButton
                            //onClick={() => handleRemoveQuestion(block.id, qIndex)}
                            onClick={() => {
                              setIsShowConfirmDeleteQuestion(true)
                              setDeleteId(quiz.id)
                              setDeleteBlockId(block.id)
                              setDeleteQuizIndex(qIndex)
                            }}
                            className="rs-btn-ghost-cancel"
                            appearance="ghost"
                            icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                            style={{ marginRight: 10 }}
                          >
                            ลบคำถาม
                          </IconButton>
                        )}

                        <Row style={{ marginTop: 10 }}>
                          {quiz.isEdit ? (
                            <>
                              <IconButton
                                onClick={() => handleSubmit(block.id, quiz.id)}
                                className="rs-btn-ghost-save"
                                appearance="ghost"
                                icon={<Icon icon="save" className="bt-gost-icon-radius" />}
                                style={{ marginRight: 10 }}
                              >
                                บันทึก
                              </IconButton>

                              <IconButton
                                onClick={() =>{
                                  updateQuestionAndChoice(block.id, quiz.id, 'isEdit', false)
                                  resetQuestionAndChoice(block.id, quiz.id)
                                }}
                                className="rs-btn-ghost-cancel"
                                appearance="ghost"
                                icon={<Icon icon="close" className="bt-gost-icon-radius-cancel" />}
                                style={{ marginRight: 10 }}
                              >
                                ยกเลิก
                              </IconButton>
                            </>
                          ) : (
                            <IconButton
                              onClick={() =>
                                updateQuestionAndChoice(block.id, quiz.id, 'isEdit', true)
                              }
                              className="rs-btn-ghost-edit"
                              appearance="ghost"
                              icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                              style={{ marginRight: 10 }}
                            >
                              แก้ไข
                            </IconButton>
                          )}
                        </Row>
                      </>
                    )}
                  </div>
                </Row>
              </Panel>
            ))}
          </Panel>
        ))}

        {assessmentId && !disabledForm && (
          <Button onClick={() => handleAddBlock()} appearance="primary" icon={<Icon icon="plus" />}>
            เพิ่มชุดคำถาม
          </Button>
        )}

        {/* <Row>
          <Col lg={16} md={16} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <SaveButton onClick={handleSubmit} style={{ marginRight: 10, marginBottom: 10 }}>
              บันทึก
            </SaveButton>
            <CancelButton onClick={handleCancel}>ยกเลิก</CancelButton>
          </Col>
        </Row> */}
      </Panel>
      <br />
      <br />
      <br />

      <ConfirmWidget
        title={formSchema?.form?.categoryType?.label || `เลือกประเภทแบบประเมิน`}
        show={isShowSelectCategoryType}
        size="md"
        selfLoadingOff={true}
        detail={''}
        onCancle={() => {
          history.push({
            pathname: pathname.assessment.assessmentSettingPage,
          })
        }}
        onConfirm={() => {
          if (categoryTypeSelected) {
            setIsShowSelectCategoryType(false)
          } else {
            notification.open('error', {
              title:
                'กรุณา' + `${formSchema?.form?.categoryType?.label || 'เลือกประเภทแบบประเมิน'}`,
              duration: 5000,
            })
          }
        }}
      >
        {renderSelectCategoryType()}
      </ConfirmWidget>

      <ConfirmWidget
        title={'บันทึกเงื่อนไขแบบประเมิน'}
        show={isShowConfirmSaveHeader}
        detail={'ยืนยันการบันทึกเงื่อนไขแบบประเมิน'}
        onCancle={() => setIsShowConfirmSaveHeader(false)}
        onConfirm={() => handleSubmitHeader()}
      />

      <ConfirmWidget
        title={'ลบหมวดหมู่และชุดคำถาม'}
        show={isShowConfirmDeleteCategory}
        size="md"
        detail={'ยืนยันการลบหมวดหมู่และชุดคำถาม ชุดคำถามทั้งหมดภายใต้หมวดหมู่นี้จะถูกลบ'}
        onCancle={() => setIsShowConfirmDeleteCategory(false)}
        onConfirm={() => handleDeleteCategory()}
      />

      <ConfirmWidget
        title={'ลบคำถาม'}
        show={isShowConfirmDeleteQuestion}
        detail={'ยืนยันการลบคำถาม'}
        onCancle={() => setIsShowConfirmDeleteQuestion(false)}
        onConfirm={() => handleDeleteQuestion()}
      />
    </>
  )
}

const ratingOptions = [
  {
    value: 1,
    label: '1',
  },
  {
    value: 2,
    label: '2',
  },
  {
    value: 3,
    label: '3',
  },
  {
    value: 4,
    label: '4',
  },
  {
    value: 5,
    label: '5',
  },
  {
    value: 6,
    label: '6',
  },
  {
    value: 7,
    label: '7',
  },
  {
    value: 8,
    label: '8',
  },
  {
    value: 9,
    label: '9',
  },
  {
    value: 10,
    label: '10',
  },
]

const location = [
  {
    id: '1',
    label: 'จังหวัด A',
    value: '1',
    children: [
      {
        id: '11',
        label: 'อำเภอ A',
        value: '1-1',
        children: [
          {
            id: '111',
            label: 'ตำบล A',
            value: '1-1-1',
            children: [
              {
                id: '1111',
                label: 'รหัสไปรษณีย์ A',
                value: '1-1-1-1',
              },
            ],
          },
          {
            id: '112',
            label: 'ตำบล AA',
            value: '1-1-2',
            children: [
              {
                id: '1121',
                label: 'รหัสไปรษณีย์ AA',
                value: '1-1-2-1',
              },
            ],
          },
        ],
      },
      {
        id: '12',
        label: 'อำเภอ AB',
        value: '1-2',
        children: [
          {
            id: '121',
            label: 'ตำบล AB',
            value: '1-2-1',
            children: [
              {
                id: '1211',
                label: 'รหัสไปรษณีย์ AB',
                value: '1-1-1-1',
              },
            ],
          },
          {
            id: '122',
            label: 'ตำบล AC',
            value: '1-2-2',
            children: [
              {
                id: '1221',
                label: 'รหัสไปรษณีย์ AC',
                value: '1-2-2-1',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: '2',
    label: 'จังหวัด B',
    value: '2',
    children: [
      {
        id: '21',
        label: 'อำเภอ B',
        value: '2-1',
        children: [
          {
            id: '211',
            label: 'ตำบล B',
            value: '2-1-1',
            children: [
              {
                id: '2111',
                label: 'รหัสไปรษณีย์ B',
                value: '2-1-1-1',
              },
            ],
          },
          {
            id: '212',
            label: 'ตำบล BB',
            value: '2-1-2',
            children: [
              {
                id: '2121',
                label: 'รหัสไปรษณีย์ BB',
                value: '2-1-2-1',
              },
            ],
          },
          {
            id: '213',
            label: 'ตำบล BC',
            value: '2-1-3',
            children: [
              {
                id: '2131',
                label: 'รหัสไปรษณีย์ BC',
                value: '2-1-3-1',
              },
            ],
          },
        ],
      },
    ],
  },
]
